<template>
  <div class="word_5" ref="huiyuan" style="padding-bottom: 50px">
        <div class="a4">
            <h1 style="font-size: 30px;font-weight: 600;">贵州省建筑业协会单位会员入会申请表</h1>
            <p style="font-size: 24px;line-height:40px">我单位自愿申请加入贵州省建筑业协会，承认本会章程，享受会员权利的同时，愿意履行会员义务和积极缴纳会费。</p>
            <div class="th">
                <div class="box justify-center" style="width:140px;height:50px">单位全称</div>
                <div class="box justify-center" style="width:580px;height:50px">{{ alldata.unitname }}</div>
            </div>
            <div class="th">
                <div class="box justify-center" style="width:140px;height:80px">在黔机构名称</div>
                <div class="box justify-center" style="width:220px;height:80px">{{ alldata.corporatename }}
                    <span class="tick">（省外企业填写）</span>
                </div>
                <div class="box justify-center" style="width:141px;height:80px">隶属关系</div>
                <div class="box justify-center" style="width:221px;height:80px">{{ alldata.Subordination }}
                    <span class="tick">（省外企业填写）</span>
                </div>
            </div>
            <div class="th">
                <div class="box justify-center" style="width:140px;height:60px">统一社会信用代码</div>
                <div class="box justify-center" style="width:220px;height:60px">{{ alldata.creditcode }}</div>
                <div class="box justify-center" style="width:141px;height:60px">法人身份证号</div>
                <div class="box justify-center" style="width:221px;height:60px">{{ alldata.IDnumber }}</div>
            </div>
            <div class="th">
                <div class="box justify-center" style="width:140px;height:50px">单位地址</div>
                <div class="box justify-center" style="width:580px;height:50px">{{ alldata.Unitaddress }}</div>
            </div>
            <div class="th">
                <div class="box justify-center" style="width:140px;height:60px">主项资质类别</div>
                <div class="box justify-center" style="width:200px;height:60px">{{ alldata.category }}</div>
                <div class="box justify-center" style="width:181px;height:60px">主项资质等级</div>
                <div class="box justify-center" style="width:201px;height:60px">{{ alldata.level }}</div>
            </div>
            <div class="th">
                <div class="box justify-center" style="width:140px;height:60px">联系人姓名</div>
                <div class="box justify-center" style="width:200px;height:60px">{{ alldata.Contactname }}</div>
                <div class="box justify-center" style="width:181px;height:60px">手机号码</div>
                <div class="box justify-center" style="width:201px;height:60px">{{ alldata.phone }}</div>
            </div>
            <div class="th">
                <div class="box justify-center" style="width:140px;height:60px">在黔机构负责人姓名</div>
                <div class="box justify-center" style="width:220px;height:60px">{{ alldata.personincharge }}
                    <span  class="tick">（省外企业填写）</span>
                </div>
                <div class="box justify-center" style="width:181px;height:60px">联系人QQ：</div>
                <div class="box justify-center" style="width:181px;height:60px">{{ alldata.qq }}</div>
            </div>
            <div class="th">
                <div class="box justify-center" style="width:140px;height:60px">办公电话</div>
                <div class="box justify-center" style="width:220px;height:60px">{{ alldata.Officetelephone }}</div>
                <div class="box justify-center" style="width:181px;height:60px">会员证字号</div>
                <div class="box justify-center" style="width:181px;height:60px">{{ alldata.Subordination }}</div>
            </div>
            <div class="th">
                <div class="box justify-center" style="width:140px;height:180px">申请单位</div>
                <div class="box justify-start" style="width:580px;height:180px;padding:10px">法定代表人签字：
                    <div class="Seal">
                        <span>（单位盖章）</span>
                        <span>年    月    日</span>
                    </div>
                </div>
            </div>
            <div class="th">
                <div class="box justify-center" style="width:140px;height:180px">贵州省建筑业协会批准</div>
                <div class="box justify-start" style="width:580px;height:180px;padding:10px">负责人签字：
                    <div class="Seal">
                        <span>（单位盖章）</span>
                        <span>年    月    日</span>
                    </div>
                </div>
            </div>
            <h4 style="text-align:start;margin:10px 0">填表说明：</h4>
            <p style="text-align:start">一、企业营业执照、资质证书、安全生产许可证（均扫描件上传）；。<br/>
                二、“会员证字号”由省建筑业协会填写。<br/>
                三、单位地址栏（省内企业填注册地址或通讯地址；入黔企业填企业原注册地址及在黔通讯地址）<br/>
                四、企业简介及优质项目展示（企业自行上传）</p>
        </div>
        <div class="botview">
      <div class="a3">
        <div class="th" style="padding: 0 60px">
          <div class="box justify-center" style="width: 146px; height: 240px">
            营业执照（入黔企业必须上传在黔分公司营业执照）
          </div>
          <div class="box justify-center" style="width: 146px; height: 240px">
            主项资质证书
          </div>
          <div class="box justify-center" style="width: 146px; height: 240px">
            安全生产许可证
          </div>
          <div class="box justify-center" style="width: 146px; height: 240px">
            社团登记证
          </div>
          <div class="box justify-center" style="width: 146px; height: 240px">
            入会申请表
          </div>
        </div>
        <div class="th" style="padding: 0 60px">
          <div class="box justify-center" style="width: 146px; height: 240px">
              <a v-if="alldata.Businesslicense1.length>0" :href="alldata.Businesslicense1[0].url">有</a>
          </div>
          <div class="box justify-center" style="width: 146px; height: 240px">
              <a v-if="alldata.Businesslicense2.length>0" :href="alldata.Businesslicense2[0].url">有</a>
          </div>
          <div class="box justify-center" style="width: 146px; height: 240px">
              <a v-if="alldata.Businesslicense3.length>0" :href="alldata.Businesslicense3[0].url">有</a>
          </div>
          <div class="box justify-center" style="width: 146px; height: 240px">
              <a v-if="alldata.Businesslicense4.length>0" :href="alldata.Businesslicense4[0].url">有</a>
          </div>
          <div class="box justify-center" style="width: 146px; height: 240px">
              <a v-if="alldata.Businesslicense5.length>0" :href="alldata.Businesslicense5[0].url">有</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import '../word/pdfview.less'
export default {
  props: {
    alldata: {
      type: Object,
    },
  },
  data() {
    return {
      mdStyle: {},
      pdfandimg: [],
      loadingTask: "",
      numPages: null,
      url: "",
    };
  },
  mounted() {
    console.log(this.alldata);
    this.$emit("huangguoshu", this.$refs.huiyuan); //整页DOM上传至父组件
  },
  methods: {
    fn() {},
  },
};
</script>

<style lang="less" scoped>
</style>